import { Badge } from '@ibsys/kit';
import { ArrowUpRightIcon } from 'lucide-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useConversationLink } from '@/entities/conversations';
import type { StrategistConceptExample } from '@/entities/strategist';

type Props = {
  example: StrategistConceptExample;
};

/**
 * Пример понятия: кто говорит, дословный текст реплики и переход в диалог примера.
 * Возврат из диалога ведёт обратно в раздел по общему контракту возврата
 * ({@link useConversationLink}).
 */
export const ConceptExample: FC<Props> = ({ example }) => {
  const { t } = useTranslation('strategist');
  const buildLink = useConversationLink();
  const isEmployee = example.speaker === 'E';
  const { to, state } = buildLink(example.cid);

  return (
    <div className="flex flex-col gap-2 rounded-xl border border-border bg-card p-3">
      <div className="flex items-center justify-between gap-2">
        <Badge variant={isEmployee ? 'primary' : 'secondary'} outline>
          {isEmployee ? t('conceptCard.speaker.employee') : t('conceptCard.speaker.client')}
        </Badge>
        <Link
          to={to}
          state={state}
          className="flex shrink-0 items-center gap-1 text-sm text-primary hover:text-primary/80"
        >
          {t('conceptCard.openDialog')}
          <ArrowUpRightIcon className="size-4" />
        </Link>
      </div>
      <p className="text-sm text-foreground whitespace-pre-wrap">{example.text}</p>
    </div>
  );
};
